import dayjs from "dayjs";
import { factoryProcessTemplatesFields } from "../Constantes/factoryProcessFields";
import calendarIcon from "../images/calendar.svg";
import dropdownIcon from "../images/arrow-down.svg";
import searchIcon from "../images/ui-ic-search.svg";
import { CaseStates } from "../Constantes/CaseStates";
import purpleIcon from "../images/circle-purple.svg";
import blueIcon from "../images/circle-blue.svg";
import greenIcon from "../images/iconActivo.svg";
import { jwtDecode } from "jwt-decode";

export function parseJwtToken() {
  let token = localStorage.getItem("apoloCRM_Token");
  if (token != null) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(""),
    );
    return JSON.parse(jsonPayload);
  }

  return null;
}

export function isTokenExpired() {
  let token = localStorage.getItem("apoloCRM_Token");
  if (!token) return true;
  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decodedToken.exp < currentTime;
  } catch (error) {
    console.error("Error decoding token:", error);
    return true;
  }
}

export function isUserInRole(role, userRoles, superAdmin) {
  if (superAdmin) return true;

  if (userRoles) {
    let roles = userRoles.map((r) => r.role.roleName || r);
    return roles.includes(role);
  }
  return false;
}

export function isUserInRoles(allowedRoles, userRoles, superAdmin) {
  if (superAdmin) return true;

  if (userRoles) {
    let roles = userRoles.map((r) => r.role.roleName || r);
    return allowedRoles.some((ar) => ar === "*" || roles.includes(ar));
  }
  return false;
}

export function _base64ToArrayBuffer(base64) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
}

export function convertToLocalTime(UTCdate, format) {
  const date = dayjs.utc(UTCdate);
  const timezone = dayjs.tz.guess();
  const result = dayjs(date)
    .tz(timezone)
    .format(format ? "DD/MM/YYYY HH:mm" : null);
  if (result === "Invalid Date") {
    return null;
  }
  return result;
}

export function convertToUTC(localDate) {
  const date = new Date(localDate);
  const result = dayjs.utc(date).format();
  if (result === "Invalid Date") {
    return null;
  }
  return result;
}
export function getTimeZone() {
  return dayjs.tz.guess();
}
export function getUTCOffset() {
  //offset in minutes
  const utcOffset = dayjs().utcOffset();

  return Math.round(utcOffset / 60);
}

export function deleteStrangeCharacters(text) {
  return text.replace(
    /[^(\u0000-\u007F \u0080-\u00FF \u0100-\u017F \u2000-\u206F \u2070-\u209F \u20A0-\u20CF)]/gi,
    "",
  );
}

export function urlToB64(caseId) {
  let url;
  const baseUrl = window.location.origin;
  const urlParam = `/?cod_cliente=${caseId}&callid=@callid@`;
  url = baseUrl + urlParam;
  const toB64 = btoa(url);
  return toB64;
}

export function getClaimsRequestFormData(dataDoc, template) {
  const data = {};
  const fields = factoryProcessTemplatesFields?.filter(
    (x) =>
      (x.templateType === template && x.isFormData) ||
      (!x.templateType && x.isFormData) ||
      (Array.isArray(x) &&
        x.every((y) => y.templateType === template && y.isFormData)),
  );
  fields.forEach((x) => {
    if (Array.isArray(x)) {
      x.forEach((y) => {
        data[y.value] = dataDoc[y.value];
      });
    } else {
      data[x.value] = dataDoc[x.value];
    }
  });
  return data;
}

export function renderDateIcon() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <img style={{ height: "2rem", width: "2rem" }} src={calendarIcon} />
    </div>
  );
}

export function renderDropdownIcon() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <img style={{ height: "2rem", width: "1.25rem" }} src={dropdownIcon} />
    </div>
  );
}

export function getCaseStateIcon(stateId) {
  const stateIdString = stateId.toString();

  switch (stateIdString) {
    case CaseStates.CLOSED.toString():
    case CaseStates.NOT_MANAGED.toString():
      return greenIcon;
    case CaseStates.IN_PROGRESS.toString():
      return blueIcon;
    default:
      return purpleIcon;
  }
}

export function stringFormat(template, ...args) {
  if (typeof template !== "string") {
    throw new TypeError("First argument must be a string.");
  }

  return template.replace(/{(\d+)}/g, (match, index) => {
    // Ensure index is within bounds
    if (index < args.length) {
      return args[index] !== undefined && args[index] !== null
        ? args[index]
        : "";
    }
    return match; // Leave placeholder if no matching argument
  });
}

export const validateEmail = (email) => {
  if (email == null || email == undefined) return false;
  // Checks for: non-whitespace characters + @ + non-whitespace + . + non-whitespace
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};
